import { render, staticRenderFns } from "./99.vue?vue&type=template&id=355fbb64&scoped=true&"
var script = {}
import style0 from "./99.vue?vue&type=style&index=0&id=355fbb64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355fbb64",
  null
  
)

export default component.exports